import styled from "styled-components";
import { InviteIcon } from "@assets";
import {
	Button as AntButton,
} from "antd";

export const InviteLinkContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
`;



export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 12px;
  /* height: 400px;

  @media screen and (max-height: 600px) {  
    height: 300px;
  } */
`

export const ChainIconContainer = styled.div`
	margin: 70px 0 0 0;
	display: flex;
	justify-content: center;
	align-items: center;

  @media screen and (max-height: 600px) {  
    margin: 30px 0 0 0;
  }
`;

export const ChainIcon = styled(InviteIcon)`
  width: 163px;
  height: 163px;
  @media screen and (max-height: 600px) {  
    width: 140px;
    height: 140px;
  }
`;

export const InviteLinkTitle = styled.p`
	margin: 16px 0 0 0;
	text-align: center;
  color: #817774;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
`;

export const CreateLinkButton = styled(AntButton)`
	margin: 20px 0 0 0;
  padding: 17px 40px 17px;
	height: 32px;
	border-radius: 8px !important;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 4px;


  color: #13100F;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  border-radius: 12px;
  background: linear-gradient(270deg, #FFE83A 0%, #FF961B 100%);
`;

export const TermsAndConditionsContainer = styled.div`
	border-radius: 16px 16px 0px 0px;
	padding: 24px 24px 24px 24px;
  background-color: #FFF;
  min-height: calc(100vh - 400px - 70px );
`;

export const InviteLinkTerm = styled.p`
	text-align: left;
	margin: 0px;
	padding: 0px;
  color: #13100F;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 171.429% */
`;

export const InviteLinkTerms = styled.span`
	font-size: 14px;
	margin: 0px;
	padding: 0px;
	color: #9f9fa2;
	font-size: 12px;
	font-style: normal;
	font-weight: 300;
	line-height: 24px;
`;

export const CopyTitle = styled.p`
	margin-bottom: 10px;
  color: #DB7802;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const CopyLink = styled.a`
	display: block;
	text-decoration: underline;

  color: #13100F;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */

	:hover {
		color: #ffb829 !important;
		text-decoration: underline;
	}
`;


